import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './newsletter-manage.component.scss';
var NewsletterManage = /** @class */ (function (_super) {
    tslib_1.__extends(NewsletterManage, _super);
    function NewsletterManage(element) {
        return _super.call(this, element) || this;
    }
    NewsletterManage.prototype.init = function () {
        this.containerForm = this.element.querySelector('.newsletter-manage__container-modal--form');
        this.containerLoader = this.element.querySelector('.newsletter-manage__container-modal--loader');
        this.containerSuccess = this.element.querySelector('.newsletter-manage__container-modal--success');
        this.containerBtnConfirm = this.element.querySelector('.js-newsletter-manage-verify-email-group');
        this.containerInputEmail = this.element.querySelector('.js-newsletter-manage-email-group');
        this.containerInputFirstName = this.element.querySelector('.js-newsletter-manage-firstname-group');
        this.containerInputSurname = this.element.querySelector('.js-newsletter-manage-surname-group');
        this.containerInputCheckboxes = this.element.querySelector('.js-newsletter-manage-checkbox-group');
        this.form = this.element.querySelector('form.js-form-newsletter-manage');
        this.inputEmail = this.element.querySelector('.js-newsletter-manage-email');
        this.inputFirstName = this.element.querySelector('.js-newsletter-manage-firstname');
        this.inputSurname = this.element.querySelector('.js-newsletter-manage-surname');
        this.inputCheckboxes = Array.from(this.element.querySelectorAll('.js-newsletter-manage-checkbox'));
        this.btnSubmit = this.element.querySelector('.js-newsletter-manage-submit');
        this.btnConfirm = this.element.querySelector('.js-newsletter-manage-verify-email');
        this.modalSubscribed = this.element.querySelector('.js-already-subscribed');
        this.modalSubscribedClose = this.element.querySelector('.js-already-subscribed-close');
        this.modalSubscribedLabel = this.element.querySelector('.js-already-subscribed-label');
        this.modalSubscribedBtnAnotherEmail = this.element.querySelector('.js-not-found-try-againl');
        this.modalVerification = this.element.querySelector('.js-verification');
        this.modalVerificationClose = this.element.querySelector('.js-verification-close');
        this.modalVerificationLabel = this.element.querySelector('.js-verification-label');
        this.modalVerificationError = this.element.querySelector('.js-verification-error');
        this.modalVerificationContainerForm = this.element.querySelector('.js-verification-container-form');
        this.modalVerificationContainerLoader = this.element.querySelector('.js-verification-container-loader');
        this.modalVerificationBtnVerify = this.element.querySelector('.js-verification-button-verify');
        this.modalVerificationBtnResend = this.element.querySelector('.js-verification-button-resend');
        this.formOTP = this.element.querySelector('.js-verification-form');
        this.inputOTPOne = this.element.querySelector('.js-otp-1');
        this.inputOTPTwo = this.element.querySelector('.js-otp-2');
        this.inputOTPThree = this.element.querySelector('.js-otp-3');
        this.inputOTPFour = this.element.querySelector('.js-otp-4');
        this.inputOTPFive = this.element.querySelector('.js-otp-5');
        if (this.getParameterByName('subid')) {
            this.subid = this.getParameterByName('subid');
        }
        else {
            if (this.getParameterByName('sub_id')) {
                this.subid = this.getParameterByName('sub_id');
            }
            else {
                this.subid = '';
            }
        }
        if (this.getParameterByName('mc_batch_id')) {
            this.mcBatchID = this.getParameterByName('mc_batch_id');
        }
        if (this.getParameterByName('mc_job_id')) {
            this.mcJobID = this.getParameterByName('mc_job_id');
        }
        if (this.element.getAttribute('data-c-name')) {
            this.valueCName = this.element.getAttribute('data-c-name');
            this.inputFirstName.setAttribute('value', this.valueCName);
        }
        else {
            this.valueCName = '';
        }
        if (this.element.getAttribute('data-c-surname')) {
            this.valueCSurname = this.element.getAttribute('data-c-surname');
            this.inputSurname.setAttribute('value', this.valueCSurname);
        }
        else {
            this.valueCSurname = '';
        }
        if (this.element.getAttribute('data-c-email')) {
            this.valueCEmail = this.element.getAttribute('data-c-email');
            this.inputEmail.setAttribute('value', this.valueCEmail);
        }
        else {
            this.valueCEmail = '';
        }
        if (this.element.getAttribute("data-application-name")) {
            this.dataApplicationName = this.element.getAttribute("data-application-name");
        }
        else {
            this.dataApplicationName = "Application:CIB | Newsletter Subscription";
        }
        if (this.element.getAttribute("data-application-id")) {
            this.dataApplicationId = this.element.getAttribute("data-application-id");
        }
        else {
            this.dataApplicationId = "<ApplicationID>";
        }
        if (this.element.getAttribute("data-application-product")) {
            this.dataApplicationProduct = this.element.getAttribute("data-application-product");
        }
        else {
            this.dataApplicationProduct = "<ProductName>";
        }
        if (this.element.getAttribute("data-pagename")) {
            this.dataPageName = this.element.getAttribute("data-pagename");
        }
        else {
            this.dataPageName = "<PageName>";
        }
        this.sitename = newsLetterSiteName;
    };
    NewsletterManage.prototype.bindEvents = function () {
        var _this = this;
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	CHECK INTERACTION
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        this.form.addEventListener("input", function () {
            _this.analyticsFormStart();
        });
        this.formOTP.addEventListener("input", function () {
            _this.analyticsOTPFormStart();
        });
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	UPDATE BUTTON
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.btnSubmit) {
            this.btnSubmit.addEventListener('click', function (event) {
                event.preventDefault();
                var formFields = _this.form.querySelectorAll('input, select, checkbox');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.funcSubmitButton();
                }
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	CONFIRM BUTTON
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.btnConfirm) {
            this.btnConfirm.addEventListener('click', function (event) {
                event.preventDefault();
                var formFields = _this.form.querySelectorAll('input.js-newsletter-manage-email');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.funcSendOtp();
                }
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	MODAL ALREADY SUBSCRIBED
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.modalSubscribedClose) {
            this.modalSubscribedClose.addEventListener('click', function (event) {
                _this.modalSubscribed.classList.add('modal--close');
                setTimeout(function () {
                    _this.modalSubscribed.classList.add('modal--closed');
                }, 250);
            });
        }
        if (this.modalSubscribedBtnAnotherEmail) {
            this.modalSubscribedBtnAnotherEmail.addEventListener('click', function (event) {
                _this.modalSubscribed.classList.add('modal--close');
                setTimeout(function () {
                    _this.modalSubscribed.classList.add('modal--closed');
                }, 250);
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	MODAL VERIFICATION
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.modalVerificationClose) {
            this.modalVerificationClose.addEventListener('click', function (event) {
                _this.modalVerification.classList.add('modal--close');
                setTimeout(function () {
                    _this.modalVerification.classList.add('modal--closed');
                }, 250);
            });
        }
        if (this.modalVerificationBtnVerify) {
            this.modalVerificationBtnVerify.addEventListener('click', function (event) {
                event.preventDefault();
                var formFields = _this.formOTP.querySelectorAll('input, select, checkbox');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.funcVerifyOTP();
                }
            });
        }
        if (this.modalVerificationBtnResend) {
            this.modalVerificationBtnResend.addEventListener('click', function (event) {
                _this.funcResendCode();
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	CHECKBOXES
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.inputCheckboxes) {
            this.inputCheckboxes.map(function (checkbox) { return checkbox.addEventListener('click', function (event) {
                // CHECK IF ALL IS CHECKED
                var element = event.target;
                if (element.value === 'all') {
                    if (element.checked) {
                        _this.inputCheckboxes.map(function (checkbox) {
                            if (checkbox.value === 'all') {
                            }
                            else {
                                checkbox.checked = true;
                            }
                        });
                    }
                    else {
                        _this.inputCheckboxes.map(function (checkbox) {
                            if (checkbox.value === 'all') {
                            }
                            else {
                                checkbox.checked = false;
                            }
                        });
                    }
                }
                else {
                    // uncheck all checkbox
                    _this.inputCheckboxes.map(function (checkbox) {
                        if (checkbox.value === 'all') {
                            checkbox.checked = false;
                        }
                    });
                    // make sure the two mobile and desktop checkboxes are insync
                    if (element.checked) {
                        _this.inputCheckboxes.map(function (checkbox) {
                            if (checkbox.value === element.value) {
                                checkbox.checked = true;
                            }
                        });
                    }
                    else {
                        _this.inputCheckboxes.map(function (checkbox) {
                            if (checkbox.value === element.value) {
                                checkbox.checked = false;
                            }
                        });
                    }
                }
                // VALIDATION
                var valid = false;
                _this.inputCheckboxes.map(function (item) {
                    if (item.checked) {
                        valid = true;
                    }
                });
                if (valid) {
                    if (_this.btnSubmit) {
                        _this.btnSubmit.classList.remove('button--disabled');
                    }
                }
                else {
                    if (_this.btnSubmit) {
                        _this.btnSubmit.classList.add('button--disabled');
                    }
                }
            }); });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	OTP
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.inputOTPOne) {
            this.inputOTPOne.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowRight" || alpha.includes(keyCode)) {
                    _this.inputOTPTwo.focus();
                }
            });
            this.inputOTPOne.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPTwo) {
            this.inputOTPTwo.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowLeft" || alpha.includes(keyCode)) {
                    _this.inputOTPOne.focus();
                }
                else if (keyCode === "ArrowRight") {
                    _this.inputOTPThree.focus();
                }
            });
            this.inputOTPTwo.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPThree) {
            this.inputOTPThree.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowLeft" || alpha.includes(keyCode)) {
                    _this.inputOTPTwo.focus();
                }
                else if (keyCode === "ArrowRight") {
                    _this.inputOTPFour.focus();
                }
            });
            this.inputOTPThree.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPFour) {
            this.inputOTPFour.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowLeft" || alpha.includes(keyCode)) {
                    _this.inputOTPThree.focus();
                }
                else if (keyCode === "ArrowRight") {
                    _this.inputOTPFive.focus();
                }
            });
            this.inputOTPFour.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPFive) {
            this.inputOTPFive.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                if (keyCode === "ArrowLeft") {
                    _this.inputOTPFour.focus();
                }
            });
            this.inputOTPFive.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	SEND OTP
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.funcSendOtp = function () {
        var containerForm = this.containerForm;
        var containerLoader = this.containerLoader;
        var modalVerificationLabel = this.modalVerificationLabel;
        var modalVerification = this.modalVerification;
        var modalSubscribedLabel = this.modalSubscribedLabel;
        var modalSubscribed = this.modalSubscribed;
        var inputEmail = this.inputEmail;
        var funcVerification = this.funcVerification;
        var funcNoSubscription = this.funcNoSubscription;
        var analyticsFormComplete = this.analyticsFormComplete;
        var analyticsSiteError = this.analyticsSiteError;
        containerForm.classList.add('d-none');
        containerLoader.classList.remove('d-none');
        // postdata
        var postData = 'action=MANAGE&';
        if (this.inputEmail) {
            postData += 'emailAddress=' + this.inputEmail.value + '&';
        }
        if (this.sitename) {
            postData += 'site=' + this.sitename + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        postData += '&manage=managePreferences';
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/sbutils/sendEmailVerification";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            var result = response.data.result;
            if (result.includes('User sent')) {
                funcVerification(containerLoader, containerForm, modalVerificationLabel, modalVerification, inputEmail.value);
            }
            else {
                funcNoSubscription(containerLoader, containerForm, modalSubscribedLabel, modalSubscribed, inputEmail.value);
            }
            analyticsFormComplete();
        }).catch(function (response) {
            // service failed
            funcNoSubscription(containerLoader, containerForm, modalSubscribedLabel, modalSubscribed, inputEmail.value);
            analyticsSiteError("500", "Service down", "OTP Send");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION NO SUBSCRIPTION
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.funcNoSubscription = function (containerLoader, containerForm, modalLabel, modal, email) {
        // configured containers
        containerLoader.classList.add('d-none');
        containerForm.classList.remove('d-none');
        // show modal
        modalLabel.innerHTML = '<strong>' + email + '</strong>';
        modal.classList.remove('modal--close');
        modal.classList.remove('modal--closed');
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION CREATE OTP
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.funcVerification = function (containerLoader, containerForm, modalLabel, modal, email) {
        // configured containers
        containerLoader.classList.add('d-none');
        containerForm.classList.remove('d-none');
        // show modal
        modalLabel.innerHTML = '<strong>' + email + '</strong>';
        modal.classList.remove('modal--close');
        modal.classList.remove('modal--closed');
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION VERIFY OTP
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.funcVerifyOTP = function () {
        var modalVerification = this.modalVerification;
        var modalVerificationError = this.modalVerificationError;
        var modalVerificationContainerForm = this.modalVerificationContainerForm;
        var modalVerificationContainerLoader = this.modalVerificationContainerLoader;
        var overrideSubId = this.overrideSubId;
        var containerBtnConfirm = this.containerBtnConfirm;
        var containerInputEmail = this.containerInputEmail;
        var inputEmail = this.inputEmail;
        var containerInputFirstName = this.containerInputFirstName;
        var inputFirstName = this.inputFirstName;
        var containerInputSurname = this.containerInputSurname;
        var inputSurname = this.inputSurname;
        var containerInputCheckboxes = this.containerInputCheckboxes;
        var inputCheckboxes = this.inputCheckboxes;
        var btnSubmit = this.btnSubmit;
        var site = this.sitename;
        var subid = this.subid;
        var container = this;
        var formOTP = this.formOTP;
        // show loader
        modalVerificationContainerForm.classList.add('d-none');
        modalVerificationContainerLoader.classList.remove('d-none');
        // analytics
        var analyticsOTPFormComplete = this.analyticsOTPFormComplete;
        var analyticsOTPFormFail = this.analyticsOTPFormFail;
        var analyticsSiteError = this.analyticsSiteError;
        // otp code
        var OTP = "";
        OTP += this.inputOTPOne.value;
        OTP += this.inputOTPTwo.value;
        OTP += this.inputOTPThree.value;
        OTP += this.inputOTPFour.value;
        OTP += this.inputOTPFive.value;
        // postdata
        var postData = '';
        if (inputEmail) {
            postData += 'emailAddress=' + inputEmail.value + '&';
        }
        if (site) {
            postData += 'site=' + site + '&';
        }
        if (OTP) {
            postData += 'code=' + OTP + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/sbutils/getUserData";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            var result = response.data;
            if (result.name !== undefined) {
                containerBtnConfirm.classList.add('d-none');
                inputEmail.setAttribute('disabled', 'disabled');
                containerInputEmail.classList.add('form__group--disabled');
                inputFirstName.removeAttribute('disabled');
                inputFirstName.setAttribute('value', result.name);
                containerInputFirstName.classList.remove('form__group--disabled');
                inputSurname.removeAttribute('disabled');
                inputSurname.setAttribute('value', result.surname);
                containerInputSurname.classList.remove('form__group--disabled');
                containerInputCheckboxes.classList.remove('js-newsletter-manage-checkbox-group');
                inputCheckboxes.map(function (item) {
                    item.removeAttribute('disabled');
                    var topics = result.topics;
                    if (topics.includes(item.value)) {
                        item.setAttribute('checked', 'checked');
                    }
                });
                btnSubmit.classList.remove('button--disabled');
                // modal hide
                modalVerification.classList.add('modal--close');
                setTimeout(function () {
                    modalVerification.classList.add('modal--closed');
                }, 250);
                overrideSubId(container, result.subid);
                analyticsOTPFormComplete();
            }
            else {
                modalVerificationContainerForm.classList.add('d-none');
                modalVerificationContainerLoader.classList.remove('d-none');
                modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
                modalVerificationError.classList.remove('d-none');
                formOTP.reset();
                modalVerificationContainerLoader.classList.add('d-none');
                modalVerificationContainerForm.classList.remove('d-none');
                analyticsOTPFormFail();
            }
        }).catch(function (response) {
            modalVerificationContainerForm.classList.add('d-none');
            modalVerificationContainerLoader.classList.remove('d-none');
            modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
            modalVerificationError.classList.remove('d-none');
            formOTP.reset();
            modalVerificationContainerLoader.classList.add('d-none');
            modalVerificationContainerForm.classList.remove('d-none');
            analyticsSiteError("500", "Service down", "Verify OTP");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION RESEND CODE
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.funcResendCode = function () {
        var formOTP = this.formOTP;
        var modalVerificationError = this.modalVerificationError;
        var modalVerificationContainerForm = this.modalVerificationContainerForm;
        var modalVerificationContainerLoader = this.modalVerificationContainerLoader;
        // show loader
        modalVerificationContainerForm.classList.add('d-none');
        modalVerificationContainerLoader.classList.remove('d-none');
        // analytics
        this.analyticsOTPResend();
        var analyticsSiteError = this.analyticsSiteError;
        // postdata
        var postData = 'action=MANAGE&';
        if (this.inputEmail) {
            postData += 'emailAddress=' + this.inputEmail.value + '&';
        }
        if (this.sitename) {
            postData += 'site=' + this.sitename + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        postData += '&manage=managePreferences';
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/sbutils/sendEmailVerification";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            var result = response.data.result;
            if (result.includes('User sent')) {
                modalVerificationContainerForm.classList.add('d-none');
                modalVerificationContainerLoader.classList.remove('d-none');
                modalVerificationError.innerHTML = "<p>We have re-sent the code to your email address.</p>";
                modalVerificationError.classList.remove('d-none');
                formOTP.reset();
                modalVerificationContainerLoader.classList.add('d-none');
                modalVerificationContainerForm.classList.remove('d-none');
            }
            else {
                modalVerificationContainerForm.classList.add('d-none');
                modalVerificationContainerLoader.classList.remove('d-none');
                modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
                modalVerificationError.classList.remove('d-none');
                formOTP.reset();
                modalVerificationContainerLoader.classList.add('d-none');
                modalVerificationContainerForm.classList.remove('d-none');
            }
        }).catch(function (response) {
            // service failed
            modalVerificationContainerForm.classList.add('d-none');
            modalVerificationContainerLoader.classList.remove('d-none');
            modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
            modalVerificationError.classList.remove('d-none');
            formOTP.reset();
            modalVerificationContainerLoader.classList.add('d-none');
            modalVerificationContainerForm.classList.remove('d-none');
            analyticsSiteError("500", "Service down", "Resend Code");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION SUBMIT BUTTON
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.funcSubmitButton = function () {
        var _this = this;
        var containerForm = this.containerForm;
        var containerLoader = this.containerLoader;
        var containerSuccess = this.containerSuccess;
        var modalSubscribedLabel = this.modalSubscribedLabel;
        var modalSubscribed = this.modalSubscribed;
        // show loader
        containerForm.classList.add('d-none');
        containerLoader.classList.remove('d-none');
        // analytics
        var analyticsFormComplete = this.analyticsFormComplete;
        var analyticsApplicationCompleted = this.analyticsApplicationCompleted;
        var analyticsSiteError = this.analyticsSiteError;
        // OTP
        var OTP = "";
        if (this.inputOTPOne) {
            OTP += this.inputOTPOne.value;
            OTP += this.inputOTPTwo.value;
            OTP += this.inputOTPThree.value;
            OTP += this.inputOTPFour.value;
            OTP += this.inputOTPFive.value;
        }
        // values
        var operation = "unsubscribe_topics";
        var inputFirstName = this.inputFirstName;
        var inputSurname = this.inputSurname;
        var inputEmail = this.inputEmail;
        var site = this.sitename;
        var contact = '';
        var formId = 'newsletter-manage-preferences';
        var topics = "";
        var topicsDataLayer = "";
        var subid = this.subid;
        var mcBatchID = this.mcBatchID;
        var mcJobID = this.mcJobID;
        this.selectedCheckboxes = [];
        this.inputCheckboxes.map(function (item) {
            if (item.checked) {
                if (item.value !== 'all') {
                    if (!_this.selectedCheckboxes.includes(item.value)) {
                        _this.selectedCheckboxes.push(item.value);
                    }
                }
            }
        });
        var arrayCheckboxesEmpty = [];
        var arrayCheckboxes = this.selectedCheckboxes;
        for (var index = 0; index < arrayCheckboxes.length; index++) {
            var topic = arrayCheckboxes[index];
            if (!arrayCheckboxesEmpty.includes(topic)) {
                if ((index + 1) === arrayCheckboxes.length) {
                    topics += topic;
                    topicsDataLayer += topic;
                    arrayCheckboxesEmpty.push(topic);
                }
                else {
                    topics += topic + ",";
                    topicsDataLayer += topic + ":";
                    arrayCheckboxesEmpty.push(topic);
                }
            }
        }
        // postdata
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (inputFirstName) {
            postData += 'firstName=' + inputFirstName.value + '&';
        }
        if (inputSurname) {
            postData += 'surname=' + inputSurname.value + '&';
        }
        if (inputEmail) {
            postData += 'email=' + inputEmail.value + '&';
        }
        if (contact) {
            postData += 'contact=' + contact + '&';
        }
        if (topics) {
            postData += 'topics=' + topics + '&';
        }
        if (site) {
            postData += 'site=' + site + '&';
        }
        if (OTP) {
            postData += 'code=' + OTP + '&';
        }
        if (subid) {
            postData += 'subId=' + subid + '&';
        }
        if (mcBatchID) {
            postData += 'mcBatchID=' + mcBatchID + '&';
        }
        if (mcJobID) {
            postData += 'mcJobID=' + mcJobID + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            var result = response.data.result;
            if (result.includes('User subscription')) {
                containerLoader.classList.add('d-none');
                containerSuccess.classList.remove('d-none');
                analyticsFormComplete(topicsDataLayer);
                analyticsApplicationCompleted();
            }
            else {
                // configured containers
                containerLoader.classList.add('d-none');
                containerForm.classList.remove('d-none');
                // show modal
                modalSubscribedLabel.innerHTML = '<strong>' + inputEmail.value + '</strong>';
                modalSubscribed.classList.remove('modal--close');
                modalSubscribed.classList.remove('modal--closed');
            }
        }).catch(function (response) {
            // configured containers
            containerLoader.classList.add('d-none');
            containerForm.classList.remove('d-none');
            // show modal
            modalSubscribedLabel.innerHTML = '<strong>' + inputEmail.value + '</strong>';
            modalSubscribed.classList.remove('modal--close');
            modalSubscribed.classList.remove('modal--closed');
            analyticsSiteError("500", "Service down", "Submission");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	GET QUERYSTRING
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.getParameterByName = function (name, url) {
        if (url === void 0) { url = window.location.href; }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	OVERRIDE SUBID
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.overrideSubId = function (container, newSub) {
        if (newSub === void 0) { newSub = ""; }
        container.subid = newSub;
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	analytics function
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterManage.prototype.analyticsFormStart = function () {
        dataLayer.formStatus = false;
        dataLayer.application.applicationName = this.dataApplicationName;
        dataLayer.application.applicationID = this.dataApplicationId;
        dataLayer.application.applicationProduct = this.dataApplicationProduct;
        dataLayer.application.applicationStart = true;
        dataLayer.application.applicationStep = "step 1";
    };
    NewsletterManage.prototype.analyticsFormComplete = function (options) {
        if (options === void 0) { options = ""; }
        dataLayer.formIsSubmitted = true;
        dataLayer.formStatus = "submitted";
        dataLayer.formOptions = options;
        _satellite.track('globalFormComplete');
        _satellite.track("globalVirtualPageView");
    };
    NewsletterManage.prototype.analyticsOTPFormStart = function () {
        dataLayer.formStatus = '';
        dataLayer.formIsSubmitted = false;
    };
    NewsletterManage.prototype.analyticsOTPFormFail = function () {
        dataLayer.otpStatus = "fail";
    };
    NewsletterManage.prototype.analyticsOTPFormComplete = function () {
        dataLayer.otpStatus = "pass";
        dataLayer.formIsSubmitted = true;
        dataLayer.formStatus = "submitted";
        _satellite.track('globalFormComplete');
        _satellite.track("globalVirtualPageView");
    };
    NewsletterManage.prototype.analyticsOTPResend = function () {
        _satellite.track("otpResend");
    };
    NewsletterManage.prototype.analyticsApplicationCompleted = function () {
        dataLayer.userRegistrationSuccess = true;
        dataLayer.application.applicationStart = false;
        dataLayer.application.applicationComplete = true;
        _satellite.track('globalApplicationComplete');
        _satellite.track("globalVirtualPageView");
    };
    NewsletterManage.prototype.analyticsSiteError = function (code, reason, request) {
        dataLayer.siteErrorCode = code + " | " + reason + " | " + request;
        _satellite.track("sendSiteErrorCode");
    };
    return NewsletterManage;
}(Base));
export { NewsletterManage };



//////////////////
// WEBPACK FOOTER
// ./components/newsletter-manage/newsletter-manage.component.ts
// module id = 566
// module chunks = 0